class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.baseUrl = '/cart';
    this.initEventDelegation();
    document.addEventListener('cartUpdated', this.handleCartUpdate.bind(this));
    this.updateCheckboxState();
  }

  get checkboxUpsellVariantId() {
    return document.querySelector('#cart-upsell-checkbox')?.getAttribute('data-variant-id');
  }

  getActiveCartInstance() {
    return document.querySelector('cart-drawer-items') || document.querySelector('cart-items') || this.cartItemsInstance;
  }

  setLoading(isLoading) {
    document.querySelectorAll('.cart-upsell').forEach((el) => el.classList.toggle('is-loading', isLoading));
  }

  initEventDelegation() {
    document.body.addEventListener('change', (event) => {
      if (event.target.id === 'cart-upsell-checkbox') {
        this.setLoading(true);
        if (event.target.checked) {
          this.addUpsellCheckboxToCart();
        } else {
          this.removeUpsellCheckboxFromCart();
        }
      }
    });
  }

  updateCheckboxState() {
    fetch(`${this.baseUrl}.js`)
      .then(response => response.json())
      .then(cart => {
        const variantId = this.checkboxUpsellVariantId;
        const hasUpsellCheckbox = cart.items.some(item => item.variant_id.toString() === variantId);
        const checkbox = document.querySelector('#cart-upsell-checkbox');
        if (checkbox) {
          checkbox.checked = hasUpsellCheckbox;
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      })
      .finally(() => this.setLoading(false));
  }

  handleCartUpdate() {
    setTimeout(() => this.updateCheckboxState(), 500);
  }

  addUpsellCheckboxToCart() {
    const formData = new FormData();
    formData.append('id', this.checkboxUpsellVariantId);
    formData.append('quantity', 1);

    fetch(`${this.baseUrl}/add.js`, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      const cartInstance = this.getActiveCartInstance();
      if (response.ok && cartInstance && typeof cartInstance.onCartUpdate === 'function') {
        cartInstance.onCartUpdate();
        this.onCartUpdateCheckboxUpsell();
      }
      return response.json();
    })
    .catch(error => {
      console.error('Error adding cart upsell:', error);
    })
    .finally(() => this.updateCheckboxState());
  }

  removeUpsellCheckboxFromCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const variantId = this.checkboxUpsellVariantId;
        const lineItemIndex = cart.items.findIndex(item => item.variant_id.toString() === variantId);
        const cartInstance = this.getActiveCartInstance();
        if (lineItemIndex !== -1 && cartInstance) {
          cartInstance.updateQuantity(lineItemIndex + 1, 0, null, null);
        } else {
          this.updateCheckboxState();
        }
      })
      .catch(error => {
        console.error('Error fetching cart for cart upsell removal:', error);
        this.updateCheckboxState();
      });
  }

  getSectionsToRenderCheckboxUpsell() {
    const mainCartItems = document.getElementById('main-cart-items');
    const sections = [
      ...(mainCartItems ? [{
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      }] : []),
      ...(mainCartItems ? [{
        id: 'main-cart-shipping',
        section: mainCartItems.dataset.id,
        selector: '#main-cart-shipping',
      }] : []),
      ...(mainCartItems ? [{
        id: 'main-cart-discount',
        section: mainCartItems.dataset.id,
        selector: '#main-cart-discount',
      }] : []),
      ...(mainCartItems ? [{
        id: 'main-cart-total',
        section: mainCartItems.dataset.id,
        selector: '#main-cart-total',
      }] : []),
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
    return sections;
  }

  onCartUpdateCheckboxUpsell() {
    this.getSectionsToRenderCheckboxUpsell().forEach(section => {
      fetch(`${routes.cart_url}?section_id=${section.section}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          if (section.id === 'main-cart-items') {
            const newContents = doc.querySelectorAll('.js-contents');
            const currentContents = document.querySelectorAll('.js-contents');

            newContents.forEach((newContent, index) => {
              const currentContent = currentContents[index];
              if (currentContent && newContent) {
                currentContent.innerHTML = newContent.innerHTML;
              }
            });

          } else if (section.id === 'cart-icon-bubble') {
            const container = document.querySelector(section.selector);
            if (container) {
              container.innerHTML = html;
            } else {
              console.error(`Container not found for selector: ${section.selector}`);
            }

          } else if (['main-cart-shipping', 'main-cart-discount', 'main-cart-total'].includes(section.id)) {
            const newElement = doc.querySelector(section.selector);
            const currentElement = document.querySelector(section.selector);

            if (currentElement && newElement) {
              currentElement.innerHTML = newElement.innerHTML;
            } else if (!currentElement) {
              console.error(`Element not found for selector: ${section.selector}`);
            }
          }
        })
        .catch(error => console.error(`Error updating section ${section.id}:`, error));
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.__occhioCartUpsellInit) return;
  const cartItemsInstance = document.querySelector('cart-items');
  const cartDrawerItemsInstance = document.querySelector('cart-drawer-items');
  const activeCartInstance = cartDrawerItemsInstance || cartItemsInstance;
  if (activeCartInstance) {
    window.__occhioCartUpsellInit = true;
    new CartCheckboxUpsell(activeCartInstance);
  }
});
